export default __webpack_public_path__ + "static/media/benefit7.87a84611.svg";